import { useContext } from "react";
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import { db } from "../../../firebase/config.js";
import { useFirestore } from "../../../firebase/useFirestore";
import { AGENDA_VIEW_OPTIONS } from "../../../helpers/calendar/resolveAgendaView";

const DefaultAgendaView = () => {
    const [, setSaved] = useContext(SavedIcon);
    const compagny = useFirestore("CompagnyMeta");

    const viewHandler = (docid, view) => {
        db.collection("CompagnyMeta")
        .doc(docid)
        .update({
            DefaultAgendaView: view
        })
        .then(() => {
            setSaved('flex');
        });
    };

    return (
        <div className="dashboard-container">
            <h2>Standaard agendaweergave</h2>
            <p>
                Kies welke weergave de agenda standaard toont bij het openen.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Standaard weergave</p>
                    <select
                        value={comp.DefaultAgendaView || 'timeGridWeek'}
                        onChange={(e) => viewHandler(comp.docid, e.target.value)}
                    >
                        {AGENDA_VIEW_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
};

export default DefaultAgendaView;
